<template>
  <div class="steps">
    <div
      v-for="(item, index) in titles"
      :key="index"
      :class="['item', index == titles.length - 1 ? 'isLast' : '']"
    >
      <div :class="['title', index <= current ? 'title-active' : '']">
        {{ item }}
      </div>
      <div class="bottom">
        <div
          v-if="index < titles.length - 1"
          :class="['line', index < current ? 'line-done' : '']"
        ></div>
        <div
          :class="[
            'text',
            current == index
              ? 'text-active'
              : index < current
              ? 'text-done'
              : '',
          ]"
        >
          {{ index + 1 }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    current: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      titles: ["注册账号", "完善信息", "注册成功"],
    };
  },
};
</script>

<style lang="scss" scoped>
.steps {
  position: relative;
  width: 100%;
  display: flex;
  padding-bottom: 50px;

  .item {
    flex-basis: 50%;
    flex-shrink: 1;
    position: relative;
    display: inline-block;

    .title {
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #727384;
      line-height: 16px;
      margin-bottom: 19px;
      text-align: left;
    }
    .title-active {
      color: #cd3232;
    }

    .bottom {
      position: relative;
      width: 100%;
      margin-left: 14px;
    }
    .line {
      position: absolute;
      border-top: 2px dashed #727383;
      height: 0;
      top: 17px;
      left: 0;
      right: 0;
    }
    .line-done {
      border-color: #cd3232;
    }

    .text {
      position: relative;
      width: 36px;
      height: 36px;
      display: flex;
      justify-content: center;
      align-items: center;

      z-index: 1;
      font-size: 18px;
      font-family: Helvetica;
      color: #727384;
      border-radius: 50%;
      border: 1px solid;
      border-color: #727384;
      background-color: #ffffff;
    }
    .text-active {
      background-color: #cd3232;
      border-color: #cd3232;
      color: #ffffff;
    }
    .text-done {
      background-color: #ffffff;
      border-color: #cd3232;
      color: #cd3232;
    }
  }
  .isLast {
    flex-basis: auto !important;
    flex-shrink: 0;
    flex-grow: 0;
    max-width: 33.3333%;
  }
}
</style>